<script>
    import { onMount } from 'svelte'
    import { db } from './firebase'
    import Header from './Header.svelte'
    export let params = {}
    import { push } from 'svelte-spa-router'


    let formTitle = 'View Form Results'
    let formData = []
    let responses = []
	let loading = true
    let orderedRespondees = ['8hZcyxE5rSNZhKEulCvCNDRb7hA2','ElunubMyWpafoEmG4ThWuiFzQWn1','K41Dv7UlTRRm6f3FxTzaedyGH1E3','QpeGe17zAxOzqxcErYnGyxagkIL2','VM8sDMPWtrgScrk3xSSUtyFBop32','ZGt9OAbgbTVONLPPYJ44QDPUO872','o6TASdFPPFhhrCiHno8Dpecv2tI3','ohG9QVaRlyaK5uIEHpcTvCv6xwg1','xzxWNekOjrewZ8Nu0LuIeexsFvA3']
    // let viewMode = 'in-order'
    // 'ofg1zMkYOnePyCAjdr2JYx6nh213'
    let viewMode = 'Alphabetical'
    let editingFormWindow = false

    onMount(() => {
		getFormData()
	})

    const getFormData = () => {
		db.collection('forms').doc(params.form).get().then((doc) => {
			if (doc.exists) {
				formData = doc.data()
                db.collection('responses').where('form', '==', params.form).get().then((querySnapshot) => {
                    querySnapshot.forEach(doc => {
                        responses = [...responses, doc.data()]
                    })
                    loading = false
                })
			} else {
				console.log("No such document!")
			}
		}).catch((error) => {
			console.log(error);
		})
	}
    const countedResponse = (response, question) => {
        // console.log(response)
        // console.log(question)
        let responses = []
        response.forEach(response => {
            // console.log(response.responses)
            responses = [...responses, response.responses[question]]
        })
        // console.log(responses)

        let counted = responses.reduce((countsMap, item) => countsMap.set(item, countsMap.get(item) + 1 || 1), new Map())
        // console.log(counted)
        return ''
    }
    const shuffleArray = (array, question) => {
        // Create an array of just responses for current question, then sort randomlu
        let questionResponses = []
        array.forEach((response) => {
            questionResponses = [...questionResponses, response.responses[question]]
        })
        return questionResponses.sort(() => Math.random() - 0.5)
    }
    const sortArray = (array, question) => {
        // Create an array of just responses for current question, then sort alphabetically
        let questionResponses = []
        array.forEach((response) => {
            questionResponses = [...questionResponses, response.responses[question]]
        })
        questionResponses = questionResponses.sort()

        // // console.log(questionResponses.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {}))
        // let countedQuestionResponses = []

        // questionResponses.forEach((response, index) => {
        //     let currentAnswerCount = 0
        //     if (response == questionResponses[index - 1]) {
        //         currentAnswerCount++
        //     } else {
        //         currentAnswerCount = 0
        //     }
        //     countedQuestionResponses = [...countedQuestionResponses, String(response) + ' (' + currentAnswerCount + ')']
        // })
        // // return questionResponses.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {})
        return questionResponses
    }
    const countAlike = (questionResponse, question, questionType) => {
        const counts = {}
        let array = sortArray(questionResponse, question)
        if (questionType == 'single-choice' || questionType == 'slider-10') {
            array.forEach(function (x) {
                counts[x] = (counts[x] || 0) + 1
            })
        } else if (questionType == 'multiple-choice' || questionType == 'multiple-choice-with-maximum') {
            let splitArray = []
            array.forEach((x) => {
                splitArray = splitArray.concat(x.split(','))
            })
            splitArray.forEach(function (x) {
                // x = x.split(',')
                counts[x] = (counts[x] || 0) + 1
            })
        } else if (questionType == 'rank-list') {
            array.forEach((response) => {
                console.log(response)
                const responseLine = response.split(',')
                responseLine.forEach((responseItem, index) => {
                    // counts[responseItem] = (counts[responseItem] || 0) + 1
                    console.log(responseItem)
                    console.log(responseLine.length - index)
                })
            })
            console.log(counts)
        }
        return counts
    }
    const toggleViewMode = () => {
        if (viewMode == 'Alphabetical') { viewMode = 'In-order'}
        else if (viewMode == 'In-order') {viewMode = 'Alphabetical'}
    }
</script>

{#if !loading}
<div class="page">
	<div class="sidebar">
		<input type="text" class="search">
		<div class="form">
			<div class="line"/>
			<p class="name">OKS Census v6</p>
			<p class="label">50 questions</p>
		</div>
	</div>
	<div class="content">
		<div class="title-bar">
			<div class="label-button" on:click={() => push('/' + params.form + '/edit')}>Go to Edit</div>
			<p class="title">{formData.title}</p>
			<div class="save-button" on:click={toggleViewMode}>{viewMode}</div>
			<!-- <div class="save-button"><img src="/assets/tick.svg" alt="" class="icon">Save</div> -->
		</div>
        {#each formData.questions as question, index}
        <div class="question">
                <!-- <p> <span class="question-label">{index + 1} - </span> {question.question} <span class="label"> ({question.type})</span></p> -->
                <p class="question-label"><span>{index + 1}</span></p>
                <h2>{question.question}</h2>
                <p class="question-type">{question.type}</p>
                <div class="question-responses">
                    {#if viewMode == 'In-order'}
                    <!-- <img src={formData.user + ".png"} alt=""> -->
                        {#each responses as response, index2}
                            <li class="in-order"><span class="user">{response.userName} wrote :</span>  {response.responses[index]}</li>
                        {/each}
                        {countedResponse(responses, index)}
                    {:else if viewMode == 'Anonymous'}
                    <ul>
                        {#each shuffleArray(responses, index) as response}
                            <li>{response}</li>
                        {/each}
                    </ul>
                    {:else if viewMode == 'Alphabetical'}
                    <ul>
                        {#each sortArray(responses, index) as response}
                            <li>{response}</li>
                            {/each}
                            <!-- {#if question.type == 'single-choice'}
                            {/if} -->
                            {JSON.stringify(countAlike(responses, index, question.type))}
                        </ul>
                    {/if}
                </div>
            </div>
        {/each}
    </div>
</div>

        <!-- <button on:click={() => viewMode = 'alphabetical'}>alphabetical</button> -->
    <!-- </div>
    <button on:click={() => viewMode = 'in-order'}>in-order</button>
    <button on:click={() => viewMode = 'anonymous'}>anonymous</button>
    <button on:click={() => viewMode = 'alphabetical'}>alphabetical</button> -->
{/if}

<style>
    .question {
        margin-bottom: 60px;
    }
    .question-responses {
        margin-top: 20px;
    }
    button.form-settings {
        position: absolute;
        top: 0px;
        right: 0px;
    }
    .question li {
        background: #222;
        border-radius: 6px 6px 6px 0;
        min-width: 400px;
        width: min-content;
        padding: 8px 28px;
        margin-bottom: 8px;
    }
    .question li.in-order {
        margin-left: 50px;
        list-style: none;
    }
    .question .user {
        opacity: 0.6;
        font-size: small;
    }
    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        float: left;
    }

	.question {
		display: grid;
		grid-template: 60px 1fr / 45px 1fr;
		margin: 50px 7%;
	}
	.question .question-label {
		grid-row: 1;
		grid-column: 1;
		align-self: start;
	}
	.question .h2, .question h2 {
		grid-row: 1;
		grid-column: 2;
		align-self: start;
	}
	.question .question-type {
		grid-row: 1;
		grid-column: 2;
		align-self: end;
		margin: 0;
	}
	.question span, .question .question-responses {
		grid-row: 2;
		grid-column: 2;
	}
	.question .max-selections-input {
		grid-column: 2;
		grid-row: 3;
	}
</style>